import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DefaultIndexDoc } from '@app/graphql';
import { ParamsType } from '@app/constants';
//import { DataService } from '@app/data';

@Component({
  selector: 'app-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.less']
})
export class CardComponent {

	@Input() article: any = {};
  @Input() displayPage?: boolean;
	@Input() queryParams!: ParamsType;
  @Input() orphan: boolean = false;

  public getQueryParams = (queryParams: ParamsType, article: DefaultIndexDoc, orphan: boolean): ParamsType => {
    //console.log('CardComponent getQueryParams article ', article);

    if (orphan) {
      return {
        sekce: article.path_page instanceof Array ? article.path_page[0] : article.path_page
      };
    }
    else {
      return queryParams;
    }
  }; 
}
